import { render, staticRenderFns } from "./SubscriptionPricesForm.vue?vue&type=template&id=6ad4b1b7&"
import script from "./SubscriptionPricesForm.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPricesForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports